import React from 'react';
import PropTypes from 'prop-types';
import LoginFormV2 from '../LoginFormV2';
import LogInBackgroundImage from '../../../images/log-in-background-image.png';
import OtpBackgroundImage from '../../../images/otp-background-image.png';
import V2ArrowRightIcon from "../../../icons/V2ArrowRightIcon";

const MainLoginComponentV2 = ({ 
  text,
  logoUrl,
  supportEmail,
  supportPhone,
  supportContact, 
  email,
  errors,
  otp,
  otpError,
  showOtp,
  showOtpRequest,
  handleOtpChange,
  onReturnToLogin,
  onOtpSubmit,
  onEmailChange,
  onSubmit,
  requestOtp,
  walletBannerEnabled,
}) => {
  const copies = showOtp ? {
    title: "User verification",
    descriptionFirstLine: `To access the desired content, we need to authenticate you. Please enter the code we just sent to ${email}`,
  } : {
    title: "Welcome!",
    descriptionFirstLine: "To continue, request a one-time passcode.",
    descriptionSecondLine: "This code will be sent to your email.",
  };

  return (
    <div className="login-page-v2">
      <div className="login-page-v2__container">
        <div className="login-page-v2__background-image-container">
          <img
            src={showOtp ? OtpBackgroundImage : LogInBackgroundImage}
            className="login-page-v2__background-image"
          />
          <img
            src={logoUrl}
            className="login-page-v2__logo"
            alt="Login logo"
          />
        </div>
        <div className="login-page-v2__form-container">
          <div className="login-page-v2__form-wrapper">
            {showOtp 
              ? 
                <a
                  href="#"
                  onClick={onReturnToLogin}
                  className="login-page-v2__link-button"
                >
                  <div className="login-page-v2__back-button-icon">
                    <V2ArrowRightIcon />
                  </div>
                  Go back
                </a>
              : <h2 className="login-page-v2__eyebrow">Sign in</h2>
            }
            <div className="login-page-v2__form-inner-wrapper">
              <div className="login-page-v2__form-header-container">
                <h3 className="login-page-v2__subtitle">{copies.title}</h3>
                <div>
                  <p className="login-page-v2__description">{copies.descriptionFirstLine}</p>
                  {copies.descriptionSecondLine && (
                    <p className="login-page-v2__description">{copies.descriptionSecondLine}</p>
                  )}
                </div>
              </div>
              <LoginFormV2
                email={email}
                errors={errors}
                handleOtpChange={handleOtpChange}
                onEmailChange={onEmailChange}
                onSubmit={onSubmit}
                otp={otp}
                otpError={otpError}
                requestOtp={requestOtp}
                showOtp={showOtp}
                showOtpRequest={showOtpRequest}
                text={text}
                supportEmail={supportEmail}
                supportPhone={supportPhone}
                supportContact={supportContact}
                onOtpSubmit={onOtpSubmit}
              />
            </div>
          </div>
          { walletBannerEnabled && (
              <div className="login-page-v2__bottom-note">
                <p>If your policy is serviced by CoverWallet, please access your Wallet online account</p>
                <a href="https://my.coverwallet.com" target="_blank" rel="noopener noreferrer"
                   className="login-page-v2__bottom-link">
                  Go to Wallet
                  <span className="login-page-v2__external-link-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path d="M14 3h7v7h-2V6.414l-9.293 9.293-1.414-1.414L17.586 5H14V3z"/>
                      <path d="M5 5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7h-2v7H5V5z"/>
                    </svg>
                  </span>
                </a>
              </div>
          )}
        </div>
      </div>
    </div>
  );
};

MainLoginComponentV2.propTypes = {
  text: PropTypes.string,
  logoUrl: PropTypes.string.isRequired,
  supportEmail: PropTypes.string.isRequired,
  supportPhone: PropTypes.string.isRequired,
  supportContact: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  errors: PropTypes.array,
  otp: PropTypes.string,
  otpError: PropTypes.string,
  showOtp: PropTypes.bool.isRequired,
  showOtpRequest: PropTypes.bool.isRequired,
  onReturnToLogin: PropTypes.func.isRequired,
  onOtpSubmit: PropTypes.func.isRequired,
  handleOtpChange: PropTypes.func.isRequired,
  onEmailChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  requestOtp: PropTypes.func.isRequired,
  walletBannerEnabled: PropTypes.bool,
};

export default MainLoginComponentV2;
